<div class="testimonial-section-container">
  <div class="testimonial-cards">
    <!-- John -->
    <div class="testimonial-card">
      <div class="video-thumbnail" (click)="openVideo('John Bannoura', 'john', $event)">
        <img src="https://embed-ssl.wistia.com/deliveries/9843a40456cddbdd1170fea228268fce0ae41d19.webp?image_crop_resized=960x540" alt="John Video" />
        <div class="play-button"></div>
      </div>
      <div class="stars-row">
        <img src="https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/66e2a677130668674f6e2b6d_trust-bubble.svg" alt="Stars" />
        <span class="rating">5,0</span>
      </div>
      <div class="profile-row">
        <img class="profile-img" src="https://cdn.prod.website-files.com/66e2a677130668674f6e2b5f/67ebf7254327ca95eb99a8b3_referenz-img-klein-1.png" alt="John Bannoura" />
        <span class="profile-name"><b>John Bannoura</b></span>
      </div>
      <div class="testimonial-text">
        Ich bin John, 20 Jahre alt und komme aus Oberösterreich. Nach meiner Lehre im Einzelhandel wollte ich mehr erreichen beruflich und finanziell. Ein Bekannter erzählte mir von HorizonNet, und trotz anfänglicher Skepsis entschloss ich mich, mehr darüber zu erfahren. Nach einem Call war ich überzeugt und trat der Akademie bei.<br><br>
        Sechs Monate später kann ich sagen: Es war die beste Entscheidung meines Lebens. Ich habe viel Wissen erlangt von Fitness über Krypto bis hin zur persönlichen Weiterentwicklung. Das Beste: Ich bin nicht mehr allein, sondern Teil einer Community, die mich motiviert. Willst auch du mehr aus deinem Leben machen? Schau's dir an es könnte deine Perspektive verändern!
      </div>
    </div>
  </div>
  <div class="testimonial-cta">
    <app-apply-button [darkCounter]="true"></app-apply-button>
  </div>
</div> 